// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"8da8e855","276":"05389386","355":"d9857221","360":"4e8423bb","694":"a1dd3fd3","739":"6a5ccff9","793":"d9857221","928":"3772bc79","946":"ca6ea3f7"}[chunkId] + ".chunk.css";
};